<script setup lang="ts">
import { useRoute } from 'vue-router'
import PublicHeader from './PublicHeader.vue'
import PublicFooter from './PublicFooter.vue'

defineProps<{
  currentPath?: string
}>()

const route = useRoute()
</script>

<template>
  <div class="min-h-screen bg-[#f0f0f0] text-slate-900 flex flex-col relative selection:bg-lime-400 selection:text-slate-900">
    <!-- Background Pattern - Dot Grid -->
    <div
      class="fixed inset-0 pointer-events-none z-0 opacity-40"
      style="background: radial-gradient(#cbd5e1 1px, transparent 1px); background-size: 20px 20px;"
    />

    <PublicHeader />
    <main
      class="flex-grow relative z-10"
      :class="route.path === '/' ? '' : 'pt-32'"
    >
      <router-view />
    </main>
    <PublicFooter />
  </div>
</template>
